import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HOME } from "../constants/routes";
import AnimatedPage from "../components/AnimatedPage";

export default function NotFound() {
	return (
		<AnimatedPage>
			<div className="mih100vh df aic jcc bg5">
				<div className="container df fdc aic tac">
					<motion.div
						initial={{ scale: 0.8, opacity: 0 }}
						animate={{ scale: 1, opacity: 1 }}
						transition={{ delay: 0.2, duration: 0.5 }}
						className="df fdc aic"
					>
						<h1
							className="c4 fw700 mb2rem"
							style={{ fontSize: '8rem', lineHeight: '1' }}
						>
							404
						</h1>
						<h2 className="c6 fw600 fs2rem mb1rem">
							Page Not Found
						</h2>
						<p className="c6 fs1-125rem mb3rem op75" style={{ maxWidth: '500px' }}>
							Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
						</p>
						<Link
							to={HOME}
							className="df aic px2rem py1rem c1 fw600 br25px td300 dib"
							style={{
								backgroundColor: '#FC7785',
								boxShadow: '0 4px 14px 0 rgba(252, 119, 133, 0.3)',
								textDecoration: 'none'
							}}
							onMouseEnter={(e) => {
								e.target.style.backgroundColor = '#e66675';
								e.target.style.boxShadow = '0 6px 20px 0 rgba(252, 119, 133, 0.4)';
								e.target.style.transform = 'translateY(-2px)';
							}}
							onMouseLeave={(e) => {
								e.target.style.backgroundColor = '#FC7785';
								e.target.style.boxShadow = '0 4px 14px 0 rgba(252, 119, 133, 0.3)';
								e.target.style.transform = 'translateY(0)';
							}}
						>
							<svg
								className="mr0-5rem"
								style={{ width: '20px', height: '20px' }}
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M10 19l-7-7m0 0l7-7m-7 7h18"
								/>
							</svg>
							Back to Home
						</Link>
					</motion.div>
				</div>
			</div>
		</AnimatedPage>
	);
}
